import React, { Component } from 'react'
import ProjectList from "./ProjectList";
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';
import BottomSide from '../components/BottomSide';
import { Helmet } from 'react-helmet';


class ProjectsPage extends Component {

    componentDidMount() {
        //console.log("firestoreConnect status:", this.props.firestoreSatus);
        //console.log("Projects collection:", this.props.projects);
    }

    render() {
        const currentUrl = window.location.href;
        const { projects } = this.props

        return (
            <div>
                <Helmet>
                    <title>Projects - Bright Youth Community</title>
                    <meta name="description" content="Welcome to our page featuring the projects our association is involved in and the developments related to these projects. This page is like an exhibition showcasing our areas of work." />
                    <link rel="canonical" href={currentUrl} />

                    <meta property="og:title" content="Projects - Bright Youth Community" />
                    <meta property="og:description" content="Welcome to our page featuring the projects our association is involved in and the developments related to these projects. This page is like an exhibition showcasing our areas of work." />
                    <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/bycbase-c9b76.appspot.com/o/byc%2Fbyc.jpg?alt=media&token=62f03ab7-9dbe-4f98-9481-cd2d4e270b83" />
                    <meta property="og:url" content={currentUrl} />
                    <meta property="og:type" content="website" />

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content="Projects - Bright Youth Community" />
                    <meta name="twitter:description" content="Welcome to our page featuring the projects our association is involved in and the developments related to these projects. This page is like an exhibition showcasing our areas of work." />
                    <meta name="twitter:image" content="https://firebasestorage.googleapis.com/v0/b/bycbase-c9b76.appspot.com/o/byc%2Fbyc.jpg?alt=media&token=62f03ab7-9dbe-4f98-9481-cd2d4e270b83" />
                </Helmet>

                <Container className="mt-4">
                    <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item active>Projects</Breadcrumb.Item>
                    </Breadcrumb>
                </Container>

                <Container className="mt-4 mb-5">
                    <Row>
                        <Col xs={12}>
                            <h2>Projects</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <ProjectList projects={projects} />
                        </Col>
                    </Row>
                </Container>

                <div>

                    <BottomSide />
                </div>
            </div>
        )
    }
}



const mapStateToProps = (state) => {
    return {
        projects: state.firestore.ordered.projects,
        auth: state.firebase.auth
    }
}


export default compose(
    connect(mapStateToProps),
    firestoreConnect([
        { collection: 'projects' }
    ])
)(ProjectsPage)